import React from 'react';
import {
  CANNOT_UNARCHIVE_PROJECT_MODAL_NAME,
  UnarchiveProjectModalData,
} from '@neptune/project-domain';
import { ArchiveLimitReachedModal } from '@neptune/project-ui';
import { useGenericModal } from '@neptune/shared/common-business-logic';

export const ArchiveModalsContainer: React.FC = () => {
  const {
    isOpen: isArchiveLimitReachedModalOpen,
    close: closeArchiveLimitReachedModal,
    data,
  } = useGenericModal<UnarchiveProjectModalData>(CANNOT_UNARCHIVE_PROJECT_MODAL_NAME);

  if (!data) {
    return null;
  }

  return (
    <ArchiveLimitReachedModal
      close={closeArchiveLimitReachedModal}
      isOpen={isArchiveLimitReachedModalOpen}
      organizationName={data.organizationName}
    />
  );
};
